import type { Address } from '@solana/kit';

import { DOPPLER_LAUNCH_HOOK_V2_PROGRAM_ADDRESS } from '../generated/dopplerLaunchHookV2/index.js';

export const DEVNET_DOPPLER_LAUNCH_HOOK_V2_PROGRAM_ID: Address =
  DOPPLER_LAUNCH_HOOK_V2_PROGRAM_ADDRESS;
export const DOPPLER_LAUNCH_HOOK_V2_PROGRAM_ID =
  DEVNET_DOPPLER_LAUNCH_HOOK_V2_PROGRAM_ID;

export const DOPPLER_LAUNCH_HOOK_V2_CONFIG_SEED = 'doppler_launch_hook_v2';
export const DOPPLER_LAUNCH_HOOK_V2_MAX_COSIGNERS = 32;

export const DOPPLER_LAUNCH_HOOK_V2_PAYLOAD_MAGIC = new Uint8Array([
  0x44, 0x4c, 0x48, 0x56, 0x32, 0x5f, 0x5f, 0x5f,
]);
export const DOPPLER_LAUNCH_HOOK_V2_PAYLOAD_VERSION = 2;
export const DOPPLER_LAUNCH_HOOK_V2_PAYLOAD_LEN = 112;

export const DOPPLER_LAUNCH_HOOK_V2_FEATURE_DYNAMIC_FEE = 1 << 0;
export const DOPPLER_LAUNCH_HOOK_V2_FEATURE_COSIGN_GATE = 1 << 1;
export const DOPPLER_LAUNCH_HOOK_V2_FEATURE_FEE_REHYPOTHECATION = 1 << 2;
export const DOPPLER_LAUNCH_HOOK_V2_FEATURE_MASK =
  DOPPLER_LAUNCH_HOOK_V2_FEATURE_DYNAMIC_FEE |
  DOPPLER_LAUNCH_HOOK_V2_FEATURE_COSIGN_GATE |
  DOPPLER_LAUNCH_HOOK_V2_FEATURE_FEE_REHYPOTHECATION;

export const DOPPLER_LAUNCH_HOOK_V2_GATE_DISABLED = 0;
export const DOPPLER_LAUNCH_HOOK_V2_GATE_UNIX_TIMESTAMP = 1;
export const DOPPLER_LAUNCH_HOOK_V2_GATE_SLOT = 2;
